<template>
    <v-sheet fill-height>
        <v-container fill-height>
            <v-row align="center" justify="center">
                <v-col lg="4" xl="3">
                    <v-card class="card-center" fill-height color="black" dark outlined elevation="8" style="min-height:40vh">
                        <v-card-text class="pos-r">
                            <div class="ripple accent-color circle pos-a"></div>
                            <BrandLogoLoader dark :width="4" :gutter="8" show-loading color="accent" />
                        </v-card-text>
                        <v-spacer />
                        <v-card-text class="shrink pa-0">
                            <h3 class="mb-5">Upgrading your experience</h3>
                            <CountDownTimer :time="time" color="accent" :interval="100" @ended="_redirect" height="52" />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-sheet>
</template>

<script>
    import CountDownTimer from "@/components/CountDownTimer.vue";
    export default {
        name: "VersionUpdate",

        components: {
            CountDownTimer,
        },

        data() {
            return {
                time: 10000
            }
        },

        methods: {
            _redirect() {
                document.location.href = "/dashboard";
                // this.$router.push("/");
            }
        },
    }
</script>

<style scoped>
    h3 {
        font-family: 'Lobster', cursive;
        font-weight: lighter;
        letter-spacing: 4px;
    }
</style>